export enum CasePreviewCardTypeEnum {
  NoDeal = 'NO_DEAL',
  HasDeal = 'HAS_DEAL',
  CaseOpened = 'CASE_OPENED',
}
